// Configuration des textes multilingues pour les soirées étapes

export const businessStayTexts = {
  fr: {
    pageTitle: 'Soirées Étapes',
    subtitle: 'Formules professionnelles tout compris',
    intro: {
      title: 'Soirées Étapes Professionnelles',
      description: 'Nos soirées étapes sont spécialement conçues pour les professionnels en déplacement. Profitez d\'une formule complète incluant l\'hébergement, le dîner et le petit-déjeuner pour un séjour sans souci.'
    },
    formula: {
      title: 'La formule comprend',
      items: [
        'Hébergement en chambre confortable',
        'Dîner au restaurant (entrée + plat + dessert)',
        'Petit-déjeuner buffet'
      ]
    },
    packages: [
      {
        id: 'traditional',
        title: 'Soirée Étape Traditionnelle',
        description: 'Notre formule classique avec hébergement en chambre Single, idéale pour un séjour professionnel confortable et économique.',
        room: 'Chambre Single',
        price: 74
      },
      {
        id: 'design',
        title: 'Soirée Étape Design',
        description: 'Notre formule premium avec hébergement en chambre Design primée, pour un séjour professionnel alliant confort et élégance.',
        room: 'Chambre Design',
        price: 99
      }
    ],
    booking: {
      title: 'Réservation',
      description: 'Pour réserver votre soirée étape, contactez-nous directement par téléphone ou par email.',
      phoneLabel: 'Téléphone',
      emailLabel: 'Email'
    },
    priceInfo: 'Prix nets par personne, taxe de séjour en sus (1,90€)',
    advantages: {
      title: 'Pourquoi choisir nos soirées étapes ?',
      items: [
        {
          title: 'Formule tout compris',
          description: 'Un seul prix pour votre hébergement, votre dîner et votre petit-déjeuner'
        },
        {
          title: 'Cuisine maison',
          description: 'Des plats traditionnels normands préparés sur place avec des produits frais'
        },
        {
          title: 'Emplacement idéal',
          description: 'Au cœur de Villedieu-les-Poêles, proche des axes routiers principaux'
        },
        {
          title: 'Parking gratuit',
          description: 'Stationnement sécurisé à disposition de nos clients'
        }
      ]
    }
  },
  en: {
    pageTitle: 'Business Stays',
    subtitle: 'All-inclusive professional packages',
    intro: {
      title: 'Professional Business Stays',
      description: 'Our business stays are specially designed for professionals on the move. Enjoy a complete package including accommodation, dinner and breakfast for a worry-free stay.'
    },
    formula: {
      title: 'The package includes',
      items: [
        'Accommodation in a comfortable room',
        'Dinner at the restaurant (starter + main course + dessert)',
        'Buffet breakfast'
      ]
    },
    packages: [
      {
        id: 'traditional',
        title: 'Traditional Business Stay',
        description: 'Our classic package with Single room accommodation, ideal for a comfortable and economical business stay.',
        room: 'Single Room',
        price: 74
      },
      {
        id: 'design',
        title: 'Design Business Stay',
        description: 'Our premium package with accommodation in an award-winning Design room, for a business stay combining comfort and elegance.',
        room: 'Design Room',
        price: 99
      }
    ],
    booking: {
      title: 'Booking',
      description: 'To book your business stay, contact us directly by phone or email.',
      phoneLabel: 'Phone',
      emailLabel: 'Email'
    },
    priceInfo: 'Net prices per person, tourist tax extra (€1.90)',
    advantages: {
      title: 'Why choose our business stays?',
      items: [
        {
          title: 'All-inclusive package',
          description: 'One price for your accommodation, dinner and breakfast'
        },
        {
          title: 'Homemade cuisine',
          description: 'Traditional Norman dishes prepared on site with fresh products'
        },
        {
          title: 'Ideal location',
          description: 'In the heart of Villedieu-les-Poêles, close to main roads'
        },
        {
          title: 'Free parking',
          description: 'Secure parking available for our guests'
        }
      ]
    }
  }
};

// Fonction utilitaire pour récupérer les textes en fonction de la langue
export const getBusinessStayText = (lang, path) => {
  const keys = path.split('.');
  let result = businessStayTexts[lang];
  
  for (const key of keys) {
    if (result && result[key] !== undefined) {
      result = result[key];
    } else {
      return undefined;
    }
  }
  
  return result;
};

// Fonction pour obtenir un package spécifique par son ID
export const getPackageById = (lang, packageId) => {
  const packages = businessStayTexts[lang]?.packages || businessStayTexts.fr.packages;
  return packages.find(pkg => pkg.id === packageId);
};
